import { createLucideIcon } from 'lucide-react';
export const GalleryIcon = createLucideIcon('gallery', [
  [
    'path',
    {
      d: 'M13 15.5L16.5 12L22 17',
      key: 'cb7tub',
    },
  ],
  [
    'path',
    {
      d: 'M16.5 20L8 10.5L2 17',
      key: '1w6t5l',
    },
  ],
  [
    'path',
    {
      d: 'M2 4H22V20H2V4Z',
      key: 'qmfu4v',
    },
  ],
  [
    'circle',
    {
      cx: '18.5',
      cy: '7.5',
      r: '1',
      fill: 'var(--contrast)',
      key: '182cq8',
    },
  ],
]);
